"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.regexp.to-string");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.init = init;

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/toConsumableArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _netUtils = require("@onviobr/net-utils");

var _constants = require("./constants");

var deregister;
var header = 'User-Time-Zone-Offset-Minutes';

function init() {
  var _context;

  var domainAllowList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  if (deregister) {
    deregister();
  }

  deregister = (0, _netUtils.injectHeaders)((0, _defineProperty2.default)({}, header, function (_, headersOrReq, headersOrNone) {
    var headers = headersOrNone || headersOrReq;
    return headers[header.toLowerCase()] || headers[header] || new Date().getTimezoneOffset().toString();
  }), (0, _concat.default)(_context = [_constants.currentDomainRegex, _constants.interceptorAllowedDomains]).call(_context, (0, _toConsumableArray2.default)(domainAllowList)));
  return function () {
    if (deregister) {
      deregister();
      deregister = null;
    }
  };
}
